import { useMutation, useQueryClient } from "@tanstack/react-query";
import { showErrorAlert } from "../../utils/showErrorAlert";
import { showSuccessToast } from "../../utils/showToastAlert";

/**
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {(key: string) => string} deps.t
 */
export function usePutPolicy({ callApiWithWorker, t }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["updatePolicy"],

    mutationFn: async ({ id, payload }) => {
      if (!id) {
        throw new Error("Policy id is required to update a policy");
      }

      const res = await callApiWithWorker(`/policy-templates/${id}`, {
        method: "PUT",
        body: payload,
      });

      const statusCode = res?.statusCode ?? res?.data?.statusCode;
      const bodyString = res?.body ?? res?.data?.body;

      if (statusCode && statusCode >= 400) {
        let message = "Policy update failed";
        try {
          const parsed =
            typeof bodyString === "string"
              ? JSON.parse(bodyString)
              : bodyString;
          message = parsed?.message ?? message;
        } catch {}
        throw new Error(message);
      }

      return bodyString;
    },

    onSuccess: async (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ["policy", id] });

      queryClient.invalidateQueries({ queryKey: ["policies"] });

      showSuccessToast(t("updateSubMessage"), {
        title: t("updateMessage"),
      });
    },

    onError: (error) => {
      showErrorAlert(error);
    },
  });
}
